import React from 'react';
import { Box } from '@mui/material';

// =============================================================================
// AppSourceBadge
// -----------------------------------------------------------------------------
// Microsoft's "Get it from Microsoft AppSource" badge, linking to Restack's
// listing. It is the one third-party logo the marketing site carries.
//
// Microsoft supplies the artwork (Partner Center go-to-market toolkit) and does
// not allow it to be redrawn or altered, so this renders nothing until that
// file sits in public/badges/ and BADGE_SRC names it. Use the full-colour
// version (white type on black) as supplied, resized only with its aspect
// ratio intact.
// =============================================================================

export const APPSOURCE_LISTING_URL = 'https://marketplace.microsoft.com/en-us/product/WA200010426';

const BADGE_SRC = null;

export function AppSourceBadge({ height = 40, sx }) {
  if (!BADGE_SRC) return null;
  return (
    <Box
      component="a"
      href={APPSOURCE_LISTING_URL}
      target="_blank"
      rel="noopener noreferrer"
      sx={{
        display: 'inline-flex',
        borderRadius: '6px',
        transition: 'opacity 0.2s ease, transform 0.12s ease',
        '&:hover': { opacity: 0.88 },
        '&:active': { transform: 'translateY(1px)' },
        '&:focus-visible': { outline: '2px solid #B83B1D', outlineOffset: 3 },
        '@media (prefers-reduced-motion: reduce)': { transition: 'none', '&:active': { transform: 'none' } },
        ...sx,
      }}
    >
      <Box
        component="img"
        src={BADGE_SRC}
        alt="Get it from Microsoft AppSource (opens in a new tab)"
        height={height}
        sx={{ display: 'block', height, width: 'auto' }}
      />
    </Box>
  );
}

export default AppSourceBadge;
